// components/Apps/Quiz/BooleanAnswerOptions.js
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Atoms';

const BooleanAnswerOptions = ({ optionA, optionB, selectedAnswer, onAnswer }) => {
  return (
    <div className="quiz-boolean">
      <Button
        variant={selectedAnswer === 'a' ? 'solid' : 'outline'}
        onClick={() => onAnswer('a')}
        className="quiz-boolean__option"
      >
        {optionA}
      </Button>
      <Button
        variant={selectedAnswer === 'b' ? 'solid' : 'outline'}
        onClick={() => onAnswer('b')}
        className="quiz-boolean__option"
      >
        {optionB}
      </Button>
    </div>
  );
};

BooleanAnswerOptions.propTypes = {
  optionA:        PropTypes.string.isRequired,
  optionB:        PropTypes.string.isRequired,
  selectedAnswer: PropTypes.string,
  onAnswer:       PropTypes.func.isRequired,
};

export default BooleanAnswerOptions;